import type { ReactNode } from 'react';

import { NavigationContextProvider } from '@/app/navigation-context/navigation-context-provider.js';
import { WorkspaceProvider } from '@/app/workspace/workspace-provider.js';

interface RouterBoundProvidersProps {
  children: ReactNode;
}

/** Providers that require react-router context (e.g. useNavigate). */
export function RouterBoundProviders({ children }: RouterBoundProvidersProps) {
  return (
    <NavigationContextProvider>
      <WorkspaceProvider>{children}</WorkspaceProvider>
    </NavigationContextProvider>
  );
}
